/**
 * 邀请文案.
 *
 * 邀请信息只写进剪贴板, 页面上只展示邀请码本身(见 AGENTS 12 的 UI 一致性要求);
 * 站点域名集中在这里一处定义, 以后换域名只改这里;
 * 品牌名跟随界面语言 (中文汇智英语 / 英文 SageHub).
 */

import { brandName } from './i18n'

/** 对外站点域名(注册入口) */
const INVITE_SITE = 'https://app.theclaw.shop/#/register'

/** 生成分享给好友的邀请文案 */
export function buildInviteText(code: string, inviter: string): string {
  return `${inviter} 邀请你注册${brandName()}，首次注册赠送 1 天会员。邀请码: ${code}，注册地址：${INVITE_SITE}`
}
